/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Empty, Skeleton, message, Popconfirm } from 'antd'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'

import AddForm from './addForm'
import ViewQRCode from './viewQRCode'
import IDTemplate from './idTemplate'
import UserAvatar from '../../../components/Custom/UserAvatar'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isAddFormShown: false,
			selectedOfficer: null,
			isViewQRCode: false,
			isIDShown: false,
			isGenerating: false
		}
	}

	render() {
		const { isAddFormShown, selectedOfficer, isViewQRCode, isIDShown, isGenerating } = this.state
		const { AuthStore, barangayPosition } = this.props
		const { barangay_term_uid, barangay_uid } = AuthStore
		
		return (
			<Row>
				<Query 
					query={BARANGAY_OFFICERS_BY_POSITION} 
					variables={{ barangay_term_uid, barangay_position_uid: barangayPosition.uid }}
				>
					{({ loading, error, data }) => {
						if (error) return <Empty/>
						if (loading) return <Skeleton active/>

						let officers = _.has(data,'barangayOfficersPerPosition') ? data.barangayOfficersPerPosition : []
						return (
							<React.Fragment>
								{
									(officers.length < barangayPosition.max_count) &&
									<Row style={{ marginBottom: '10px' }}>
										<a style={{ color: 'blue', cursor: 'pointer' }} onClick={() => {
											this.setState({ isAddFormShown: true })
										}}>+ Add Officer <i>({officers.length} of {barangayPosition.max_count})</i></a>
									</Row>
								}
								<Row gutter={32} style={{ marginLeft: 15 }}>
									{
										officers.map((officer, key) => (
											<Col key={key} md={12} sm={24} style={{ position: 'relative', marginTop: 15 }}>
												<UserAvatar size={70} user_uid={officer.uid} />
												<h4 style={{ display: 'inline-block', marginLeft: 10 }}>{officer.full_name}</h4> &nbsp;
												<small><a style={{ marginLeft: '10px', color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => {
													this.setState({ isAddFormShown: true, selectedOfficer: officer })
												}}>Edit</a></small>
												<Popconfirm
													title="Are you sure delete this staff?"
													onConfirm={() => {
														const { deleteStaff } = this.props
														deleteStaff(officer.uid).then((response) => {
															//create audit trail
															const auditParams = {
																module_name: 'Utilities',
																action: 'Delete',
																message: `Deleted staff ${officer.full_name}`
															}
															AuthStore.saveAuditTrail(auditParams)

															message.success('Staff successfully deleted.')
															window.location.reload()
														}).catch(err => {
															console.log('error deleting staff', err)
															message.error(err.message.replace('GraphQL error:', ''))
														})
													}}
													// onCancel={cancel}
													okText="Yes"
													cancelText="No"
												>
													<small>
														<a style={{ marginLeft: '10px', color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}>Delete</a>
													</small>
												</Popconfirm>
												
												<small><a style={{ marginLeft: '10px', color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => {
													this.setState({ isViewQRCode: true, selectedOfficer: officer })
												}}>QR Code</a></small>
												{/* <small><a style={{ marginLeft: '10px', color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => {
													this.setState({ isIDShown: true, selectedOfficer: officer })
												}}>ID TEMPLATE</a></small> */}
												{
													(officer.avatar_file_uid) &&
													<small><a disabled={isGenerating} style={{ marginLeft: '10px', color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => {
														const { generateID } = this.props
														this.setState({ isGenerating: true }, () => {
															generateID({ barangay_uid, officer_uid: officer.uid })
																.then(resp => {
																	const { file_url } = resp.data.generateIDTemplate
																	window.open(`${process.env.REACT_APP_BACKEND_API}${file_url}`, '_blank')
																	this.setState({ isGenerating: false })
																	message.success('ID Template successfully generated')
																})
																.catch(err => {
																	console.log('error generating id', err)
																	this.setState({ isGenerating: false })
																	message.err(err.message.replace('GraphQL error:', ''))
																})
														})
													}}>ID TEMPLATE</a></small>
												}
											</Col>
										))
									}
								</Row>
							</React.Fragment>
						)
					}}
				</Query>
				{
					isAddFormShown &&
                    <AddForm 
                    	visible={isAddFormShown}
                    	onClose={() => this.setState({ isAddFormShown: false, selectedOfficer: null })}
                    	barangay_term_uid={barangay_term_uid}
                    	barangay_uid={barangay_uid}
                    	selectedBarangayPosition={barangayPosition}
                    	selectedOfficer={selectedOfficer}
                    />
				}
				{
					isViewQRCode &&
					<ViewQRCode 
						visible={isViewQRCode}
						onClose={() => this.setState({ isViewQRCode: false, selectedOfficer: null })}
						selectedOfficer={selectedOfficer}
					/>
				}
				{
					isIDShown &&
					<IDTemplate 
						officer={selectedOfficer}
						visible={isIDShown}
						onCancel={() => this.setState({ isIDShown: false, selectedOfficer: null })}
					/>
				}
			</Row>
		)
	}
}

const BARANGAY_OFFICERS_BY_POSITION = gql`
    query barangayOfficersPerPosition($barangay_term_uid: String, $barangay_position_uid: String) {
		barangayOfficersPerPosition(barangay_term_uid: $barangay_term_uid, barangay_position_uid: $barangay_position_uid)
    }
`

const GENERATE_ID = gql`
    mutation generateIDTemplate($input: JSON) {
		generateIDTemplate(input: $input)
    }
`

const DELETE_OFFICER = gql`
    mutation deleteBarangayStaff($officer_uid: String) {
		deleteBarangayStaff(officer_uid: $officer_uid)
    }
`

const composed = compose(
	inject('AuthStore'),
	graphql(GENERATE_ID, {
		props({ mutate }) {
			return {
				generateID(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangayPositions','barangayOfficersPerPosition','userAvatar']
					})
				}
			}
		}
	}),
	graphql(DELETE_OFFICER, {
		props({ mutate }) {
			return {
				deleteStaff(officer_uid) {
					return mutate({
						variables: { officer_uid },
					  	refetchQueries: ['barangayPositions','barangayOfficersPerPosition']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
